export default "__VITE_ASSET__95fa8b42__"